export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full py-10 px-10 md:px-16 bg-secondary-100">
      <div className="w-full max-w-[1440px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-foreground-600">
          &copy; {year} Rm Software. All rights reserved.
        </p>
        <p className="text-sm text-foreground-500">
          Toronto, Canada
        </p>
      </div>
    </footer>
  );
}